import { PageHeader, Stack, Tab, TabList } from "@justworkshr/milo-core";
import { ReactElement, useEffect } from "react";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import styles from "../../InternationalSolutionsPage.module.css";
import EORPriceCard from "../../components/Cards/EORPriceCard";
import LookingForContractorCard from "../../components/Cards/LookingForContractorCard";
import { TABS } from "../../constants";
import EorBannerImage from "../../images/eor-banner.png";
import { FAQ_PATH, OVERVIEW_PATH, RESOURCES_PATH } from "../../routes";
import { Faq } from "./Faq";
import Overview from "./Overview";
import Resources from "./Resources";
import { useGetCompanyDisplayQuery } from "types/generated/operations";
import { trackPdpEvent } from "app/market-expansion/event-tracking";

const EmployerOfRecord = (): ReactElement => {
  const { container, column1, column2 } = styles;

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getSelectedTabIndex = (): number => {
    const index = TABS.findIndex((tab) => pathname.includes(tab.path));
    return index !== -1 ? index : 0;
  };

  const { data: memberData } = useGetCompanyDisplayQuery();

  useEffect(() => {
    if (!memberData?.authenticatedMember) return;

    const memberUuid = memberData?.authenticatedMember.uuid ?? "";
    const companyUuid = memberData?.authenticatedMember.company.uuid ?? "";

    trackPdpEvent({
      actorId: memberUuid,
      companyId: companyUuid,
      pageDomain: window.location.hostname,
      pagePath: window.location.pathname,
    });
  }, [memberData]);

  const handleTabChange = (index: number) => {
    if (index === 0) {
      return navigate(`${OVERVIEW_PATH}`);
    } else if (index === 1) {
      return navigate(`${FAQ_PATH}`);
    } else if (index === 2) {
      return navigate(`${RESOURCES_PATH}`);
    } else {
      return navigate(`${OVERVIEW_PATH}`);
    }
  };

  return (
    <>
      <PageHeader
        title="International hiring made easy"
        children={
          <span>
            Onboard, pay, and manage full-time international employees, without
            opening a local entity in key markets including
            <b> Canada, India, Mexico, Spain, and the U.K.</b>
          </span>
        }
      />
      <div className={container}>
        <div className={column1}>
          <img src={EorBannerImage} alt="" />
          <TabList
            orientation="horizontal"
            selected={getSelectedTabIndex()}
            onChange={handleTabChange}
          >
            {TABS.map((tab) => (
              <Tab key={tab.path}>{tab.name}</Tab>
            ))}
          </TabList>

          <Outlet />

          <Routes>
            <Route path={`${OVERVIEW_PATH}`} element={<Overview />} />
            <Route path={`${FAQ_PATH}`} element={<Faq />} />
            <Route path={`${RESOURCES_PATH}`} element={<Resources />} />
            <Route
              path="*"
              element={<Navigate to={`${OVERVIEW_PATH}`} replace />}
            />
          </Routes>
        </div>

        <div className={`${column2}`}>
          <Stack spacing="xl">
            <EORPriceCard />
            <LookingForContractorCard />
          </Stack>
        </div>
      </div>
    </>
  );
};

export default EmployerOfRecord;
